

















































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import TtdPadDialog from "@/components/common/TtdPadDialog.vue";
import { storePersetujuanObat } from "@/store/modules/PersetujuanObatStore";
import PersetujuanObatSvc from "@/services/PersetujuanObat";
import { storeDokter } from "@/store/modules/dokter";
import { userModule } from "@/store/modules/user";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { getHumanDateTime } from "@/utility/DateUtils";
import moment from "moment";

@Component({
  components: {
    CardModalTtd,
    TtdPadDialog
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanObat extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  showDetail = false;
  selectedItem: any = null;
  editId: number | null = null;
  modalTtd = false;
  signRole = "";
  ttdDialog = false;
  ttdNama = "";
  ttdInitial = "";
  ttdTarget: any = null;
  saving = false;
  formValid = false;

  form: any = this.getEmptyForm();

  tableHeaders = [
    { text: "Tanggal", value: "tgl_persetujuan", width: "120px" },
    { text: "Daftar Obat", value: "daftar_obat" },
    { text: "DPJP", value: "dpjp_nama", width: "180px" },
    { text: "Status TTD", value: "status_ttd", width: "120px", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "160px" },
  ];

  mounted() {
    storePersetujuanObat.getByRegister(this.register);
    storeDokter.act_dokter_all();
  }

  getEmptyForm() {
    return {
      daftar_obat: [{ nama_obat: "", keterangan: "" }],
      dpjp_id: (RegisterKunjungan.register?.dokter?.id as number) || null,
      penanda_tangan: "Pasien",
      penanda_tangan_nama: "",
      penanda_tangan_hubungan: "",
      penanda_tangan_ttd: "",
    };
  }

  get storeObat() {
    return storePersetujuanObat;
  }

  get items() {
    return storePersetujuanObat.items;
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  get stateuser() {
    return userModule.user;
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY") : "-";
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  formatDaftarObat(daftarObat: any[]) {
    if (!daftarObat || !daftarObat.length) return "-";
    return daftarObat.map(o => o.nama_obat).join(", ");
  }

  getStatusColor(item) {
    if (item.signed_dpjp && item.signed_penyetuju) return "green";
    if (item.signed_dpjp || item.signed_penyetuju) return "orange";
    return "grey";
  }

  getStatusLabel(item) {
    if (item.signed_dpjp && item.signed_penyetuju) return "Lengkap";
    if (item.signed_dpjp || item.signed_penyetuju) return "Sebagian";
    return "Belum TTD";
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("persetujuan_penggunaan_obat", "create");
  }

  canEditItem(item) {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_penggunaan_obat", "edit")) return false;
    return !item.signed_dpjp && !item.signed_penyetuju;
  }

  canSignDpjp(item) {
    if (this.readOnly) return false;
    if (!userModule.canAccessForm("persetujuan_penggunaan_obat", "sign")) return false;
    return item && !item.signed_dpjp && item.dpjp && item.dpjp.id === this.stateuser.id;
  }

  canEditItemState(item) {
    if (this.readOnly) return false;
    return !item.signed_dpjp && !item.signed_penyetuju;
  }

  canDeleteItemState(item) {
    if (this.readOnly || !item) return false;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        ...slotTandaTanganDokumen(item.signed_dpjp, item.signature_dpjp),
        { ditandatangani: item.signed_penyetuju, penandaTanganId: null }
      ],
      this.stateuser?.id
    );
  }

  canSignDpjpState(item) {
    if (this.readOnly) return false;
    return item && !item.signed_dpjp && item.dpjp && item.dpjp.id === this.stateuser.id;
  }

  onPenandaTanganChange(val: string) {
    if (val === "Pasien") {
      this.form.penanda_tangan_nama = storePasien.identitasPasien?.nama || "";
      this.form.penanda_tangan_hubungan = "";
    } else {
      this.form.penanda_tangan_nama = "";
      this.form.penanda_tangan_hubungan = "";
    }
  }

  addObat() {
    this.form.daftar_obat.push({ nama_obat: "", keterangan: "" });
  }

  removeObat(idx: number) {
    this.form.daftar_obat.splice(idx, 1);
  }

  tambah() {
    this.form = this.getEmptyForm();
    this.editId = null;
    this.showDetail = false;
    this.showForm = true;
  }

  edit(item) {
    this.editId = item.id;
    this.form = {
      daftar_obat: JSON.parse(JSON.stringify(item.daftar_obat)),
      dpjp_id: item.dpjp ? item.dpjp.id : null,
      penanda_tangan: item.penanda_tangan || "Pasien",
      penanda_tangan_nama: item.penanda_tangan_nama || "",
      penanda_tangan_hubungan: item.penanda_tangan_hubungan || "",
      penanda_tangan_ttd: item.penanda_tangan_ttd || "",
    };
    this.showDetail = false;
    this.showForm = true;
  }

  lihat(item) {
    this.selectedItem = item;
    this.showForm = false;
    this.showDetail = true;
  }

  cancelForm() {
    this.showForm = false;
    this.form = this.getEmptyForm();
    this.editId = null;
  }

  async simpan() {
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        daftar_obat: this.form.daftar_obat.filter(o => o.nama_obat),
        dpjp_id: this.form.dpjp_id,
        penanda_tangan: this.form.penanda_tangan,
        penanda_tangan_nama: this.form.penanda_tangan_nama,
        penanda_tangan_hubungan: this.form.penanda_tangan === "Keluarga Pasien"
          ? this.form.penanda_tangan_hubungan
          : null,
        penanda_tangan_ttd: this.form.penanda_tangan_ttd || null,
      };

      let resp;
      if (this.editId) {
        resp = await PersetujuanObatSvc.update(this.editId, payload);
      } else {
        resp = await PersetujuanObatSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan Penggunaan Obat berhasil disimpan");
        this.showForm = false;
        this.form = this.getEmptyForm();
        this.editId = null;
        storePersetujuanObat.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  get bisaTtdPasien(): boolean {
    if (this.readOnly) return false;
    return (
      userModule.canAccessForm("persetujuan_penggunaan_obat", "create") ||
      userModule.canAccessForm("persetujuan_penggunaan_obat", "edit")
    );
  }

  bukaTtdForm() {
    this.ttdTarget = null;
    this.ttdNama = this.form.penanda_tangan_nama || "";
    this.ttdInitial = this.form.penanda_tangan_ttd || "";
    this.ttdDialog = true;
  }

  bukaTtdPasien(item) {
    if (!this.bisaTtdPasien) return;
    this.ttdTarget = item;
    this.ttdNama = item.penanda_tangan_nama || "";
    this.ttdInitial = item.penanda_tangan_ttd || "";
    this.ttdDialog = true;
  }

  async simpanTtdPad(dataUrl: string) {
    if (!dataUrl) return;
    this.ttdDialog = false;

    if (!this.ttdTarget) {
      this.form.penanda_tangan_ttd = dataUrl;
      appModule.NoticeDelay('Tanda tangan siap — klik "Simpan" untuk menyimpan.');
      return;
    }

    await this.kirimTtdPasien(this.ttdTarget, dataUrl, "Tanda tangan tersimpan");
  }

  async hapusTtdPasien(item) {
    if (!this.bisaTtdPasien) return;
    if (!confirm("Hapus tanda tangan pasien/keluarga ini?")) return;

    await this.kirimTtdPasien(item, null, "Tanda tangan dihapus");
  }

  private async kirimTtdPasien(item, ttd: string | null, pesan: string) {
    const resp = await PersetujuanObatSvc.signPasien(item.id, ttd);

    if (resp.data?.status == "1") {
      appModule.NoticeDelay(pesan);
      this.selectedItem = resp.data.data;
      await storePersetujuanObat.getByRegister(this.register);
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const signFn =
      this.signRole === "dpjp"
        ? PersetujuanObatSvc.signDpjp
        : PersetujuanObatSvc.signPenyetuju;

    const resp = await signFn(this.selectedItem.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      const label = this.signRole === "dpjp" ? "DPJP" : "Penyetuju";
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
      appModule.addMsgTtd("");
      storePersetujuanObat.getByRegister(this.register);
      // Refresh detail view
      this.showDetail = false;
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf(item) {
    PersetujuanObatSvc.print(item.id);
  }

  async hapus(item) {
    if (!this.canDeleteItemState(item)) return;
    const q = confirm("Anda yakin akan menghapus persetujuan penggunaan obat ini?");

    if (q) {
      try {
        const resp = await PersetujuanObatSvc.destroy(item.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          storePersetujuanObat.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
